export default __webpack_public_path__ + "static/media/adminDetail.a587a84d.jpg";